import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <motion.nav 
      className={`navbar ${isScrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="navbar-container">
        <div className="navbar-content">
          <div className="navbar-logo" onClick={(e) => scrollToSection(e, 'hero')}>
            <img src="/logo.png" alt="Gebeta Tech" className="logo-image" />
            <h2>Gebeta<span>Tech</span></h2>
          </div>

          <div className="navbar-right">
            <ul className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
              <li>
                <a href="#hero" onClick={(e) => scrollToSection(e, 'hero')}>Home</a>
              </li>
              <li>
                <a href="#services" onClick={(e) => scrollToSection(e, 'services')}>Services</a>
              </li>
              <li>
                <a href="#about" onClick={(e) => scrollToSection(e, 'about')}>About</a>
              </li>
              <li>
                <a href="#portfolio" onClick={(e) => scrollToSection(e, 'portfolio')}>Portfolio</a>
              </li>
              <li>
                <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')}>Contact</a>
              </li>
            </ul>

            <button
              type="button"
              className="btn btn-primary navbar-cta"
              onClick={(e) => scrollToSection(e, 'contact')}
            >
              Get Started
            </button>
          </div>

          <div 
            className="mobile-menu-icon"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;

